/**
 * Component: sa-customize-frame-button
 * Description: Handles redirection to the customization page with the current variant ID.
 */
if (!customElements.get('sa-customize-frame-button')) {
  class SaCustomizeFrameButton extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.btn = this.querySelector('[data-customize-frame-btn]');
      if (this.btn) {
        this.btn.addEventListener('click', this.handleClick);
      }
    }

    disconnectedCallback() {
      if (this.btn) {
        this.btn.removeEventListener('click', this.handleClick);
      }
    }

    handleClick(e) {
      e.preventDefault();
      let variantId = null;

      // 1. Try to find the main product form input
      // Look for the closest product wrapper or the main product form
      const productSection = this.closest('[data-section-type="product-page"]') || document.querySelector('[data-section-type="product-page"]');

      if (productSection) {
        // Try to find input in the main product form first
        const mainFormInput = productSection.querySelector('.m-product-form--main input[name="id"]');
        if (mainFormInput) {
            variantId = mainFormInput.value;
        } else {
            const idInput = productSection.querySelector('input[name="id"]');
            if (idInput) variantId = idInput.value;
        }
      }

      // 2. Fallback: Check URL
      if (!variantId) {
        const urlParams = new URLSearchParams(window.location.search);
        variantId = urlParams.get('variant');
      }

      // 3. Fallback: Default variant from data attribute
      if (!variantId) {
        variantId = this.dataset.defaultVariantId;
      }

      const href = this.btn.getAttribute('href');
      const targetUrl = new URL(href, window.location.origin);

      if (variantId) {
        targetUrl.searchParams.set('parent_variant_id', variantId);
      }

      // Handle GPO Hidden Inputs
      const gpoContainer = productSection ? productSection.querySelector('.gpo-hidden-inputs') : document.querySelector('.gpo-hidden-inputs');
      
      if (gpoContainer) {
        const inputs = gpoContainer.querySelectorAll('input');
        const addonItems = [];

        inputs.forEach(input => {
            // 1. Add-on Product (gpo-data-variant-id)
            if (input.hasAttribute('gpo-data-variant-id')) {
                const addonId = input.getAttribute('gpo-data-variant-id');
                const fieldName = input.getAttribute('data-field-name') || input.name;
                const value = input.getAttribute('data-value') || input.value;
                
                if (addonId) {
                    addonItems.push({
                        id: addonId,
                        name: fieldName
                        // value is not needed in addonItems JSON as it's passed via standard properties
                    });
                }
            } 
            
            // 2. Properties (others with name) - Include ALL properties (including addons) for the main product record
            if (input.name) {
                const value = input.getAttribute('data-value') || input.value;
                if (value) {
                    targetUrl.searchParams.append(input.name, value);
                }
            }
        });

        if (addonItems.length > 0) {
            // Use Base64 encoding to avoid WAF issues with JSON in URL
            const jsonStr = JSON.stringify(addonItems);
            // UTF-8 safe Base64 encoding
            const base64Str = btoa(unescape(encodeURIComponent(jsonStr)));
            targetUrl.searchParams.set('addon_items', base64Str);
        }
      }

      // TODO: Temporary: Append view=customize-frame as requested
      // targetUrl.searchParams.set('view', 'customize-frame');

      window.location.href = targetUrl.toString();
    }
  }

  customElements.define('sa-customize-frame-button', SaCustomizeFrameButton);
}
